module.exports = __webpack_public_path__ + "static/media/math-green.c4e55f25.svg";